import { useMemo } from 'react';
import { useAuth } from '../auth/AuthContext';
import { createApiClient, type ApiClient } from './client';

export function useApi(): ApiClient {
  const { getToken } = useAuth();
  return useMemo(() => createApiClient(getToken), [getToken]);
}
